import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaSave } from 'react-icons/fa';
import spacesApi from '../../services/spacesApi.js';
import { colors } from '../../utils/colors.js';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Input = styled.input`
  width: 64px;
  padding: 4px 8px;
  border: 1px solid ${colors.gray[300]};
  border-radius: 6px;
  font-size: 13px;
`;

const SaveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.gray[500]};
  font-size: 14px;
  padding: 4px;

  &:hover:not(:disabled) {
    color: ${colors.primary[600]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const ScoreHint = styled.span`
  font-size: 11px;
  color: ${colors.gray[500]};
`;

export default function VerificadoCell({ space, onSaved }) {
  const [score, setScore] = useState(null);
  const [verificado, setVerificado] = useState(0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let mounted = true;
    spacesApi
      .getScore(space.id)
      .then((data) => {
        if (!mounted) return;
        setScore(data);
        setVerificado(data.verificado);
      })
      .catch(() => {
        if (mounted) setVerificado(0);
      });
    return () => {
      mounted = false;
    };
  }, [space.id]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const updated = await spacesApi.setVerificado(space.id, Number(verificado));
      setScore(updated);
      setVerificado(updated.verificado);
      onSaved?.();
    } catch (err) {
      window.alert(err.response?.data?.detail || 'Não foi possível salvar o valor de verificado.');
    } finally {
      setSaving(false);
    }
  };

  const title = score
    ? `checkin: ${score.media_checkin} | conexão: ${score.media_conexao} | assinaturas: ${score.assinaturas} | invite: ${score.invite} | avaliações: ${score.avaliacoes} | score: ${score.score}`
    : 'Carregando componentes do score...';

  return (
    <Wrapper title={title}>
      <Input
        type="number"
        min="0"
        max="10"
        step="0.1"
        value={verificado}
        onChange={(e) => setVerificado(e.target.value)}
      />
      <SaveButton type="button" onClick={handleSave} disabled={saving} title="Salvar verificado">
        <FaSave />
      </SaveButton>
      {score && <ScoreHint>score: {score.score}</ScoreHint>}
    </Wrapper>
  );
}
